import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import BucketFilled2 from '../../Assetes/Images/kfc-basket.svg';
import Button from '@mui/material/Button';
import Modal from 'react-bootstrap/Modal';
import OrderHistoryDetail from '../ProfileInfo/OrderHistoryDetail';
import moment from 'moment';
import { API_URL, priceunit } from '../../Components/client-config';
import { toast } from 'react-toastify';
import axios from 'axios';
import { connect, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { orderDetail } from '../../Redux/actions/menu';
import { useHistory } from 'react-router-dom';
import FeedBack from '../OrderOptions/FeedBack';
import SelectStoreModal from '../../Components/selectStoreModal'
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useCurrentLocale from '../../hooks/useLanguage';
import { formatPrice } from '../../utils/format-price';

function ReOrderCard(props: any) {
    const history = useHistory();
    const cartData = useSelector((state: any) => state.cart.cartData);
    const { order } = props;
    const [show, setShow] = useState(false);
    const [feedbackShow, setFeedbackShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const [selectStoreShow, setSelectStoreModal] = useState(false);
    const handleSelectStoreClose = () => setSelectStoreModal(false);
    const lang = useCurrentLocale();

    const handleClose = () => {
        setShow(false)
        setFeedbackShow(false)
    };
    const handleShow = (order_id: any) => {
        props.orderDetail(order_id, setShow)
    };
    const handleFeedback = (order_id: any) => {
        props.orderDetail(order_id, setFeedbackShow, true);

    }

    const addReorderCart = async (order_id: any) => {
        let flag = true;
        if (_.isEmpty(storeSelected)) {
            setSelectStoreModal(true)
            flag = false
        }
        let token: any = await localStorage.getItem("userToken");
        if (flag)
            setLoader(true)
        axios.get(`${API_URL}last_order/${order_id}/online`, {
            headers: { Authorization: "Bearer " + token, locale: lang },
        }).then(response => {
            if (response.data.success) {
                let selectedOrderCart = response.data.successResponse;
                if (selectedOrderCart && selectedOrderCart.length > 0) {
                    let cart = cartData;
                    if (cart && cart.length > 0) {
                        selectedOrderCart.map((cartitem: any) => {
                            cart.push(cartitem)
                        })
                        props.saveCart(cart)
                    } else {
                        props.saveCart(selectedOrderCart)
                    }
                    if (flag)
                        toast.success(`${t("YOURORDERADDEDTOCART")}`, {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000
                        });

                    setLoader(false)
                } else {
                    setLoader(false)
                    if (flag)
                        toast.error(`${t("YOURORDERNOTAVAILABLEFORNOW")}`, {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000
                        });
                }
            } else {
                setLoader(false)
                if (flag)
                    toast.error(`${t("YOURORDERNOTAVAILABLEFORREORDER")}`, {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000
                    });
            }
        }).catch(err => {
            let errMessage = err.response.data.message
            if (flag)
                toast.error(errMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000
                });
            setLoader(false)
        })
    }
    const { t } = useTranslation();
    return (
        <div>
            <div className="card reorder-card" >
                <a className='d-block text-center mt-2'>
                    {loader ?
                        <Button className='text-center history-btn bg-theme font-normal' variant="contained" color='error'>{<CircularProgress color={"inherit"} />}</Button> :
                        <Button className='text-center history-btn bg-theme font-normal' variant="contained" color='error' onClick={() => { addReorderCart(order.order_id) }}>{t("REORDER")}</Button>}
                </a>
                <img src={BucketFilled2} alt="imf" />
                <div className="card-body">
                    <h5 className="card-title">{t("ORDER")} # {order?.order_id}</h5>
                    <p className="card-text">{moment(order?.date_created).format("DD MM YYYY")}</p>
                    <h5>{priceunit} {formatPrice(order?.order_grossprice)}</h5>
                    <p className='py-1'>Status : {order?.order_status_description}</p>
                    <div className='d-flex gap-2 button-info-gap'>
                        <Button onClick={() => handleShow(order.order_id)} className='w-100 bg-theme p-0 py-1 font-normal history-btn bg-theme' variant="contained" color="error">{t("VIEWINFO")}</Button>
                        {process.env.REACT_APP_FEEDBACK_ENABLE === "true" && <Button onClick={() => handleFeedback(order.order_id)} className='w-100 p-0 py-1 font-normal bg-theme' variant="contained" color="error">{t("FEEDBACK")}</Button>}
                    </div>
                </div>
            </div>

            <Modal show={feedbackShow} onHide={handleClose} animation={false}>
                <div className='modal-design'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Header className='justify-content-center' closeButton>
                    <Modal.Title className='font-bold'>{t("HAVESOMEFEEDBACKTOSHARE")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='w-100 delivery-order'>
                    <FeedBack date={order?.date_created} setFeedbackShow={setFeedbackShow} />
                </Modal.Body>

            </Modal>

            <Modal show={show} onHide={handleClose} animation={false}>
                <div className='modal-design'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Header className='justify-content-center' closeButton>
                    <Modal.Title className='font-bold'>{t("ORDER_DETAILS")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OrderHistoryDetail />
                </Modal.Body>
            </Modal>

            <SelectStoreModal show={selectStoreShow} handleClose={handleSelectStoreClose} />

        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        orderDetail: function (order_id: any, setShow?: any, feedback?: any) {
            dispatch(orderDetail(order_id, setShow, feedback));
        }

    }
}
export default connect(null, mapDispatchToProps)(ReOrderCard);
